export default "__VITE_ASSET__CWdd7$nu__"